module.exports = __webpack_public_path__ + "img/zu1.a2546fd7.jpg";